import PathMatrix from "csi/table/matrix/Path";
import _ from "lodash";
import declare from "dojo/_base/declare";
import xml from "csi/xml";

const ImpactAnalysisAffectedItemsMatrix = declare(PathMatrix, {
	/**
	 * @override
	 * Filter out AffectedItems for ItemProducts/AffectedLibraryItems the user does not has access to
	 */
	_filterNodes (ctx, spec, nodes) {
		return _.filter(nodes, (node) => {
			return xml.nodeHasRight(ctx.cache.getNode(node.AffectedItemActualItem), xml.RIGHT_READ);
		});
	},
});

export = ImpactAnalysisAffectedItemsMatrix